/* eslint-disable prefer-const */
/* eslint-disable new-cap */
/*
 * @Author: edvardchen
 * @Date: 2017-12-06 17:30:15
 * @Last Modified by: zloongjiang
 * @Last Modified time: 2021-12-16 12:08:17
 */

// @flow
import querystring from 'query-string';
import { type Dispatch, type GetState } from '../types';

import C4PV from '../../utility/C4PV';
import { reportAccess, reportAccessOld } from '../../fetchers/PV';
import { getUrlParam } from '../../utility/reportUnitTime';
import { isCSR } from '../../utility/csrUtil';
declare var __CLIENT__: boolean;
const CITY_PREFIX = '12098_';
const TAG_APPID = 6;
const INNERCH_RELATIVE = '000204';

export default () => async (dispatch: Dispatch, getState: GetState) => {
  if (!__CLIENT__) {
    return;
  }
  const {
    article,
    location,
    user: { subscriptions },
    apn,
  } = getState();
  const { docId, url, dataSrc, subjectId, zimeitiId, fusionId } = (article: Object);
  let subscribed = 0;
  if (fusionId) {
    subscribed = subscriptions && subscriptions[fusionId] ? 1 : 0;
  }
  let {
    tagId,
    cityid = '',
    tabId,
    fromId,
    data_type: dataType,
    ctrid = '',
    extenddata = '',
    pid,
    innerCh,
    business,
    ch,
    hasreport,
    tpos = '',
  } = location.query || {};
  let tbirdParams = isCSR ? getUrlParam(window?.tbird?.location?.href || window.location.href) : {};
  const {
    pid: tpid,
    docId: tdocId,
    sStrategyId: tsStrategyId,
    subjectId: tsubjectId,
    dataSrc: tdataSrc,
    zimeitiId: tzimeitiId,
    sGrayPlatFormModelId: tsGrayPlatFormModelId,
    ch: tch,
    url: turl,
  } = tbirdParams;

  ctrid = ctrid || tbirdParams.ctrid;
  dataType = dataType || tbirdParams.data_type;

  if (ctrid && ctrid.indexOf(CITY_PREFIX) === 0) {
    const parts = ctrid.split('_');
    ctrid = parts[0] || '';
    cityid = parts[1] || '';
  }
  const extDataObj = extenddata ? querystring.parse(extenddata) : {};
  reportAccessOld({
    logType: 'access',
    oriUrl: url || turl,
    contentId: docId || tdocId,
    channel: ch || tch,
    innerCh,
    extData: extenddata,
    businessId: 'coolread',
    businessType: business || 'coolread',
    // tagId,
    // tabId,
    fromId: fromId || tabId,
    viewType: 'article',
    dataSrc: dataSrc || tdataSrc,
    subjectId: subjectId || tsubjectId,
    zimeitiId: zimeitiId || tzimeitiId,
    url: url || turl,
    pid: pid || tpid,
    data_type: dataType,
    ctrid,
    subscribed,
    contentLevel: extDataObj.contentLevel,
  });

  const isRelatedNews = innerCh === INNERCH_RELATIVE;
  let indexV = '';
  if (extDataObj.pos) {
    indexV += `index=${extDataObj.pos};`;
  }
  if (tpos) {
    indexV += `topnews=${tpos};`;
  }
  const logData: Object = {
    F7: ch || tch,
    F8: innerCh,
    F9: pid || tpid,
    F10: 1, // 日志类型（新闻、视频、直播）

    F11: dataType,
    F12: ctrid,
    F13: extDataObj.sGrayPlatFormModelId || tsGrayPlatFormModelId,

    // 相关阅读不上报这个字段
    F14: isRelatedNews ? undefined : extDataObj.sFirstStrategy,
    F15: indexV, // 某一刷的第几篇文章
    F16: extDataObj.sStrategyId || tsStrategyId,

    // // 如果是 tag 文章，这样上报
    F18: Number(pid || tpid) === TAG_APPID ? tagId : extDataObj.ctridext || cityid,
    F19: apn || '',
    F26: docId || tdocId,
    F27: dataSrc || tdataSrc,
    F28: subjectId || tsubjectId,
    F29: zimeitiId || tzimeitiId,
    F30: 1, // 普通文章、图集
    F32: url || turl,
    F33: extDataObj.contentLevel,
    F34: 0,
    F35: extDataObj.wx ? '1' : '0',
    F21: subscribed,
    F36: extDataObj.recallTagId || '',
    F37: 1,
  };
  const userData = await C4PV();
  if (hasreport && (hasreport === true || hasreport === 'true')) return;
  await reportAccess({
    ...logData,
    ...userData,
  });
};
